<template>
  <div>
    <dtjl />
  </div>
</template>

<script>
import fbpl from "../components/fbpl";
import dtjl from "../components/dtjl";
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {
    fbpl,
    dtjl,
  },
};
</script>

<style>
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/xydt/xydt.vue